// extracted by mini-css-extract-plugin
export default {"skeleton":"RowOperationsMenu__skeleton___BVoAm"};